import { h } from '@stencil/core';

import { defaultInProgressVehicleState } from '../../../utils/utils.vehicle';

const sectionHeaderClass = { 'font-open-sans mt-6 pb-6': true };
const renderDataGrouping = (options = [], heading = '', highlightLabel = false) => {
  const hasOptions = options.length > 0;
  const labelClass = {
    'font-bold': highlightLabel,
  };

  return (
    <div>
      {options.map(
        ({ label, value }) =>
          value && (
            <div>
              <span class={labelClass}>{label}:</span> {value}
            </div>
          )
      )}
      {!hasOptions && <div>No {heading.toLowerCase()} entered</div>}
    </div>
  );
};

const renderVehicleHistory = (vehicleHistory) => {
  const vehicleHistoryOptions = [
    { label: 'Original Owner', value: vehicleHistory.originalOwner },
    { label: 'Accidents', value: vehicleHistory.accidents },
    { label: 'Auctioned in Last 45 Days', value: vehicleHistory.auctionedInLast45Days },
    { label: 'Rental Vehicle', value: vehicleHistory.rentalVehicle },
  ];
  return (
    <div class={sectionHeaderClass}>
      <h3 class="mb-2">Vehicle History</h3>
      {renderDataGrouping(vehicleHistoryOptions, 'Vehicle history')}
    </div>
  );
};

const getVehicleReplacementOptions = ({ lookingFor, vehicle, year }) => {
  if (lookingFor && vehicle) {
    return [
      { label: 'Looking For', value: lookingFor },
      { label: 'Vehicle', value: vehicle },
      { label: 'Year', value: year },
    ];
  }
  return [];
};

export const VehicleDetailsModal = (
  { customer, vehicle } = {
    customer: { email: '', firstName: '', lastName: '', phone: '', zip: '' },
    vehicle: { ...defaultInProgressVehicleState },
  }
) => {
  const { email, firstName, lastName, phone, zip } = customer;
  const contactOptions = [
    { label: 'Name', value: `${firstName} ${lastName}` },
    { label: 'Email', value: email },
    { label: 'Phone', value: phone },
    { label: 'Zipcode', value: zip },
  ];

  const { description, options, replacementVehicle, history } = vehicle;
  const vehicleDescOptions = [
    { label: 'VIN', value: description.vin },
    { label: 'Vehicle', value: description.vehicle },
    { label: 'Mileage', value: description.mileage },
    { label: 'Color', value: description.color },
    { label: '2 Sets of Keys', value: description.twoSetsOfKeys },
  ];

  const vehicleOptions = [
    { label: 'Engine', value: options.engine },
    { label: 'Transmission', value: options.transmission },
    { label: 'Drive', value: options.drive },
    { label: 'Installed Options', value: ' ' },
  ];

  const SectionSeparator = () => <hr class="border-0 bg-clrs-grey h-px" />;

  return [
    <ico-modal id="offer-details" slot="modal" displayX={true}>
      <div slot="header">
        <h3 class="font-montserrat font-bold text-xl">Offer Details</h3>
        <div>Please review the information you've given us.</div>
      </div>

      <div slot="main">
        <div class={sectionHeaderClass}>
          <h3 class="mb-2">Contact Information</h3>
          {renderDataGrouping(contactOptions, 'Contact Information', true)}
        </div>

        <SectionSeparator />

        <div class={sectionHeaderClass}>
          <h3 class="mb-2">Vehicle Description</h3>
          {renderDataGrouping(vehicleDescOptions, 'Vehicle Description', true)}
        </div>

        <SectionSeparator />

        <div class={sectionHeaderClass}>
          <h3 class="mb-2">Vehicle Options</h3>
          {renderDataGrouping(vehicleOptions, 'Vehicle Options', true)}
          <ul class="columns-2 list-none p-0">
            {options.installedOptions.map((o) => (
              <li>{o}</li>
            ))}
          </ul>
        </div>

        <SectionSeparator />

        {renderVehicleHistory(history)}

        <SectionSeparator />

        <div class={sectionHeaderClass}>
          <h3 class="mb-2">Replacement Vehicle</h3>
          {renderDataGrouping(getVehicleReplacementOptions(replacementVehicle), 'Replacement Vehicle', true)}
        </div>
      </div>
    </ico-modal>,
  ];
};
